import type { TenantConfig } from '@/types/TenantConfig'

export const vanpass: TenantConfig = {
  logo: 'assets/vanpass/static/logo.png',

  themeOptions: {
    primaryColor: '#8dc63f',
    secondaryColor: '#8dc63f',
    headerBackground: '#029CCA',
    footerBackgroundColor: '#029CCA',
    footerTextColor: '#ffffff',
    logoHeight: '80px',
    cartHeaderBackgroundColor: '#029CCA',
    cartHeaderTextColor: '#ffffff',
  },

  teaserImageSize: {
    width: 320,
  },

  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/vanpass/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-180px',
        mobile: '-120px',
      },
    },
  },
}
